import { PageHeader } from "@empite/ui-components";
// The document itself, imported from the repository rather than copied into
// this file. A copy would be wrong the first time somebody edited the original,
// and a console that confidently shows a stale integration guide is worse than
// one that shows none.
import source from "../../../../docs/desktop-client-integration.md?raw";
import { Markdown, markdownTitle, outline } from "../markdown";
import { RequireOperator } from "./guards";

/**
 * The desktop client integration guide.
 *
 * Behind the operator guard like every other page — not because the content is
 * secret (it is in the repository) but because the console has exactly one
 * shape, and a page that rendered for a signed-out visitor would be the only
 * one that did.
 */
export function Guide() {
  return (
    <RequireOperator>
      {() => {
        const sections = outline(source);
        return (
          <>
            <PageHeader
              title={markdownTitle(source) || "Desktop Client Integration"}
              description="What a desktop client calls, and the credentials that make each call legal. Rendered from docs/desktop-client-integration.md, so it says what the repository says."
            />
            <nav className="esm-doc__contents" aria-label="Contents">
              <b>On this page</b>
              <ol>
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.text}</a>
                  </li>
                ))}
              </ol>
            </nav>
            <Markdown source={source} />
          </>
        );
      }}
    </RequireOperator>
  );
}
